import { httpClient } from '../httpClient';

export const riskApi = {
  getAll: () =>
    httpClient.get('/risk/all'),

  getRisks: (params) =>
    httpClient.get('/risk/risks', { params }),

  getRiskById: (id) =>
    httpClient.get(`/risk/risks/${id}`),

  createRisk: (data) =>
    httpClient.post('/risk/risks', data),

  updateRisk: (id, data) =>
    httpClient.put(`/risk/risks/${id}`, data),

  deleteRisk: (id) =>
    httpClient.delete(`/risk/risks/${id}`),

  getControls: (params) =>
    httpClient.get('/risk/controls', { params }),

  createControl: (data) =>
    httpClient.post('/risk/controls', data),

  updateControl: (id, data) =>
    httpClient.put(`/risk/controls/${id}`, data),

  deleteControl: (id) =>
    httpClient.delete(`/risk/controls/${id}`),

  getStats: () =>
    httpClient.get('/risk/stats'),

  export: (data, options) =>
    httpClient.post('/risk/export', data, options),
};
